

import React, { useMemo } from 'react';

import styled from 'styled-components';


import { purifyHTML } from '../../../../common/utils';
import { useDataContext } from '../../contexts/DataAdapterContext';







const TitleH1Base = styled.h1.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const TitleH2Base = styled.h2.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const TitleH3Base = styled.h3.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const TitleH4Base = styled.h4.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const TitleH5Base = styled.h5.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const titleComponentsMap = {
  h1: TitleH1Base,
  h2: TitleH2Base,
  h3: TitleH3Base,
  h4: TitleH4Base,
  h5: TitleH5Base
};

const Title = (props) => {
  const { title, style, computedStyle } = props;
  const { text = '', tag = 'h1', className = '' } = title;

  const titleProps = { style, computedStyle, className };

  const { isPreview } = useDataContext();

  const replacedText = useMemo(() => {
    if (isPreview && text) {
      return text.
      replace(/\$\{recipientName\}/g, '<span style="color: #27BBA1;">&lt;Recipient Name&gt;</span>').
      replace(/\$\{recipientCompany\}/g, '<span style="color: #27BBA1;">&lt;Company Name&gt;</span>').
      replace(/(?:\r\n|\r|\n)/g, '<br/>');
    }

    return text.replace(/(?:\r\n|\r|\n)/g, '<br/>');
  }, [text, isPreview]);

  const TitleComponent = titleComponentsMap[tag];

  if (!TitleComponent) {
    return null;
  }

  return (
    <TitleComponent
      {...titleProps}
      dangerouslySetInnerHTML={{ __html: purifyHTML(replacedText) }} />);


};

export default Title;